/**
 * Normalizes TipTap HTML output by cleaning up common artifacts:
 * - Removes empty <p> tags (including those with only &nbsp; or whitespace)
 * - Flattens <li><p>...</p></li> → <li>...</li>
 * - Removes consecutive <br> tags
 * - Trims the result
 */
export function normalizeTiptapHtml(input: string): string {
  if (!input || input === '<p></p>') return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${input}</div>`, 'text/html');
  const root = doc.body.firstElementChild as HTMLElement;
  if (!root) return '';

  // 1. Flatten <li><p>…</p></li> → <li>…</li>
  root.querySelectorAll('li').forEach((li) => {
    // If the only child is a single <p>, unwrap it
    if (
      li.children.length === 1 &&
      li.children[0].tagName === 'P'
    ) {
      const p = li.children[0];
      while (p.firstChild) {
        li.insertBefore(p.firstChild, p);
      }
      p.remove();
    }
  });

  // 2. Remove empty <p> tags (containing nothing, whitespace, or &nbsp;)
  root.querySelectorAll('p').forEach((p) => {
    const text = p.textContent?.replace(/\u00A0/g, '').trim() ?? '';
    const hasContent = text.length > 0 || p.querySelector('img, br');
    if (!hasContent) {
      p.remove();
    }
  });

  // 3. Remove consecutive <br> tags
  root.querySelectorAll('br + br').forEach((br) => {
    br.remove();
  });

  const result = root.innerHTML.trim();
  return result || '';
}
